// import axios from 'axios';
import {API} from './apiAuth';

// // console.log('API',API);
export const getPriceAlarm = async () => {
    try {
        const response = await API.get('price-alarms');
        return response;
    } catch (error) {
        console.error('Error get price alarms:', error);
        throw error;
    }
};


export const postPriceAlarm = async (data) => {
    try {
        let requestData = data
        // console.log('requestData',requestData);
        const response = await API.post('price-alarms',requestData);
        return response;
    } catch (error) {
        console.error('Error posting price alarms:', error);
        throw error;
    }
};

export const delPriceAlarm = async (id) => {
    try {
        let url = `price-alarms/${id}`
        const response = await API.delete(url);
        return response;
    } catch (error) {
        console.error('Error delete price alarms:', error);
        throw error;
    }
};

export const activePriceAlarm = async (id,active) => {
    try {
        let activeStatus = !active
        let url = `price-alarms/${id}/active/${activeStatus}`
        const response = await API.patch(url);
        return response;
    } catch (error) {
        console.error('Error active price alarms:', error);
        throw error;
    }
};

export const updatePriceAlarm = async (data,id) => {
    try {
        let requestData = data
        // // console.log('id',id);
        // // console.log('requestData',requestData);
        const response = await API.put(`price-alarms/${id}`,requestData);
        return response;
    } catch (error) {
        console.error('Error posting price alarms:', error);
        throw error;
    }
};
